(function($){

  let cid

  $.fn.extend({
    stickyCheckers: function(){
      var parent = $(this);
      var action;
      if( $("html").is(".android") ){
        action = 'click';
      } else{
        action = 'tap';
      }

      // 読み込み時にチェックを取得する
      $(".child [data-child]", parent).each(function(){
        var $that = $(this);
        var len = $("input:checked", this).length;

        if(len > 0){
          $that.addClass("active");
          var cid = $that.data("child");
          $(".map-area-list .map-"+ cid).addClass("active");
          $("[data-cid='"+ cid +"']").addClass("active");

          $(".map-area-list .map-"+ cid).addClass("checked");
          $("[data-cid='"+ cid +"']").addClass("checked");
          $("[data-child='"+ cid +"']").addClass("checked");
        }
      });

      $(".parent [data-cid]", parent).each(function(){
        var $that = $(this);
        var len = $("input:checked", this).length;
        if(len > 0){
          var cid = $that.data("cid");

          $(".map-area-list .map-"+ cid).addClass("checked");
          $("[data-cid='"+ cid +"']").addClass("checked");
        }
      });


      //いずれかをホバー時
      $("[data-cid], [data-mapid]", parent).hover(
        function(){
          if( $(this).data("mapid") ){ cid = $(this).data("mapid"); }
          if( $(this).data("cid") ){ cid = $(this).data("cid"); }
          parent.attr("data-current", cid);
        },
        function(){
          if( $(this).data("mapid") ){ cid = $(this).data("mapid"); }
          if( $(this).data("cid") ){ cid = $(this).data("cid"); }
          parent.attr("data-current", "");
        }
      );

      // MAPをタップした時
      $("[data-mapid]", parent).on(action, function(){
        var $li = $(this).parents().filter("li");
        var cid = $(this).data("mapid");

        if( $li.hasClass("check") ){

          var obj = $("[data-cid='"+ cid +"'] input");
          obj.prop("checked", !obj.prop("checked"));

          $("[data-cid='"+ cid +"']").toggleClass("checked");
          $(".map-area-list .map-" + cid).toggleClass("checked");
          $("[data-child='"+ cid +"']").toggleClass("checked");

        } else{
          $("[data-cid='"+ cid +"']").toggleClass("active");
          $(".map-area-list .map-" + cid).toggleClass("active");
          $("[data-child='"+ cid +"']").toggleClass("active");
        }
      });

      // 親リストの動き
      $("[data-cid]", parent).on(action, function(){
        var cid = $(this).data("cid");

        if( $(this).hasClass("toggle") ){
          $("[data-cid='"+ cid +"']").toggleClass("active");
          $(".map-area-list .map-" + cid).toggleClass("active");
          $("[data-child='"+ cid +"']").toggleClass("active");
        }

        if( $(this).hasClass("check") ){
          var obj = $("input", this);
          obj.prop("checked", !obj.prop("checked"));

          $("[data-cid='"+ cid +"']").toggleClass("checked");
          $(".map-area-list .map-" + cid).toggleClass("checked");
          $("[data-child='"+ cid +"']").toggleClass("checked");
        }
      });

      // 子要素のラベルの動き
      $(".child label, .option label", parent).on(action, function(){
        var $ul = $(this).parents().filter("[data-child]");
        var $li = $(this).parents().filter("li");
        var obj = $("input", $li);
        obj.prop("checked", !obj.prop("checked"));

        var cid = $ul.data("child");
        var len = $("input:checked", $ul).length;

        if(len > 0){
          $(".map-area-list .map-"+ cid).addClass("checked");
          $("[data-cid='"+ cid +"']").addClass("checked");
          $("[data-child='"+ cid +"']").addClass("checked");
        } else{
          $(".map-area-list .map-"+ cid).removeClass("active").removeClass("checked");
          $("[data-cid='"+ cid +"']").removeClass("active").removeClass("checked");
          $("[data-child='"+ cid +"']").removeClass("active").removeClass("checked");
        }
      });
    }
  });

  $(function(){
    $(".map-search").stickyCheckers();
    $(".check-list2").stickyCheckers();
  });

})(jQuery);




// WEBPACK FOOTER //
// ./_src/js/cont/search-map.js